import { faBan } from "@fortawesome/free-solid-svg-icons/faBan";
import { faPlus as plus } from "@fortawesome/free-solid-svg-icons/faPlus";
import { faTimes } from "@fortawesome/free-solid-svg-icons/faTimes";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons/faExclamationTriangle";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons/faCircleInfo";
import { faX } from "@fortawesome/free-solid-svg-icons/faX";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogProps,
} from "@mui/material";
import React, { useState, useRef } from "react";

import clsx from "clsx";
import globalMU from "globalMU";
import { TooltipMU } from "app/components/tooltip/TooltipMU";
import { PaperArrastavel } from "../dialog-arrastavel/PaperArrastavel";

const estiloModalConfigurarWhatsapp =
    require("./modalConfigurarWhatsapp.module.scss").default;

export type ModalConfigurarWhatsappProps = {
    qrCodeBase64: string;
    erroAoObterQrCode: boolean;
    carregandoQrCode: boolean;
    onGerarQrCode: (dados: any) => void;
    onClose: () => void;
    onApagarSessao: (inibirMensagemDeErro: boolean) => void;
};

export const ModalConfigurarWhatsapp = (
    props: ModalConfigurarWhatsappProps
) => {
    const [scroll, setScroll] = useState<DialogProps["scroll"]>("paper");
    const QR_FAKE_BASE64 =
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAfQAAAH0CAYAAADL1t+KAAAAAklEQVR4AewaftIAABoWSURBVO3BUW4ku5YEwQhC+9+yz8X7PxyAqEwV1W5W/hNJknS1FUmSdL0VSZJ0vRVJknS9FUmSdL0VSZJ0vRVJknS9FUmSdL0VSZJ0vRVJknS9FUmSdL0VSZJ0vRVJknS9FUmSdL0VSZJ0vRVJknS9FUmSdL0VSZJ0vRVJknS9FUmSdL0VSZJ0vRVJknS9FUmSdL0VSZJ0vRVJknS9FUmSdL0VSZJ0vRVJknS9FUmSdL2f/IK2+SuATNpmB8ikbU4A2WmbCZBJ20yA7LTNpwHZaZsJkEnbTIC8rW3eBuQJbTMBstM2EyCTtrkJkE9rm1NAJm1zCsikbf4KIG9akSRJ11uRJEnXW5EkSddbkSRJ11uRJEnXW5EkSddbkSRJ1/vJFwLyTdrmbUAmbfOEtnkCkEnbTIBM2uZU25xomycAOQVk0jYTIJO22QEyaZsJkLcBuUnbvA3ILYB8k7b5JiuSJOl6K5Ik6XorkiTpeiuSJOl6K5Ik6XorkiTpej+5TNs8AcinAdlpmwmQJwA50TZPAPIEIJ/WNqeATNpmAmSnbSZATgDZaZt/QdtMgJxomx0gJ9pmAmSnbf6CtnkCkFusSJKk661IkqTrrUiSpOutSJKk661IkqTrrUiSpOv9RI9pmx0gJ4B8k7Z5G5CdtjkB5BSQb9I2EyCngEzaZtI2NwHyaUDe1jZPADJpG71vRZIkXW9FkiRdb0WSJF1vRZIkXW9FkiRdb0WSJF3vJ3oMkJ22mQCZtM0EyBOATNpmB8ikbSZAvgmQt7XNE9rmFJAJkLe1zQTI29pmAmSnbSZAJkCe0DaTtpkA0ftWJEnS9VYkSdL1ViRJ0vVWJEnS9VYkSdL1ViRJ0vVWJEnS9X5yGSB/BZATQG7SNp/WNjtAJm0zaZsJkCcAmbTNDpBPa5udtpkAmbTNKSC3ADJpmx0gJ9pmAmSnbU4A+SZA/nUrkiTpeiuSJOl6K5Ik6XorkiTpeiuSJOl6K5Ik6Xo/+UJt8xe0zQ6QSdtMgEzaZgfIpG0mQE4BmbTNNwEyaZsdIJO2mQB5QttMgJwCMmmbCZBJ27ytbXaATNpmAuQJbTMBMmmbHSCTtjnRNjtATrSNZiuSJOl6K5Ik6XorkiTpeiuSJOl6K5Ik6XorkiTpej/5BUCUtM2nATkF5ASQnbaZADkB5Altc6ptJkAmbfMEIH9F20yAvA3IpG1Otc03ATJpmwmQU0B0ZkWSJF1vRZIkXW9FkiRdb0WSJF1vRZIkXW9FkiRdr/wnL2ubHSCTtjkBZKdtPg3ITttMgEza5m1AJm1zCsg3aZtTQD6tbb4NkLe1zduATNpmAuRU20yATNpmAmSnbU4AmbTNDpBJ20yAnGqbCZBJ25wC8qYVSZJ0vRVJknS9FUmSdL0VSZJ0vRVJknS9FUmSdL0VSZJ0vZ98obaZAJm0zaRtdoB8WtvsAPk0IDttc6JtJkBOtc0JIDttMwEyATJpm1NtcwLITtucADJpm5sAmbTNBMhO23xa2+wA+bS2OQXkBJCdtjnRNhMgO0A+Dcg3WZEkSddbkSRJ11uRJEnXW5EkSddbkSRJ11uRJEnX+8kXAjJpm7e1zQTIBMiptpkAuUnbnADytraZANlpmwmQE23zhLY51TYTIG9rmwmQSducAvJNgJxqmxNtcwrIibaZtM0OkL9uRZIkXW9FkiRdb0WSJF1vRZIkXW9FkiRdb0WSJF3vJ78AyE7bTICcaJudtpkAmbTNBMhO25xom1NATrTNN2mbJwCZtM0OkBNt8wQgk7aZANlpm0nbnAByCsgTgEza5gltcwLIpG12gEzaZgJk0jY3aZu/YEWSJF1vRZIkXW9FkiRdb0WSJF1vRZIkXW9FkiRd7ye/oG1Otc0JIDttM2mbJwB5W9ucADJpmx0gbwMyaZsTQHbaZgJkAuRU23xa25wCMmmbSdu8DchO23wakJ22mQB5G5BbAHlb2+wAedOKJEm63ookSbreiiRJut6KJEm63ookSbreiiRJut6KJEm63k9+AZCdtjkB5BSQE20zaZtTQCZtMwHybdrm04A8AcgpICfaZgJkB8gJIJO22QHyaUB22mbSNhMgk7Y5BeSbtM2ptjkBZAJkp20mQJ7QNhMgf8GKJEm63ookSbreiiRJut6KJEm63ookSbreiiRJut5PfkHb7AA50TYTIKfaZgJk0jbfBsikbSZtMwGy0zYTIJO2eQKQSducAjJpmwmQSducAnICyE7bTIBMgEzaZgfIibaZADnVNieA7AA5AeRU23xa25xqmwmQt7XNBMg3WZEkSddbkSRJ11uRJEnXW5EkSddbkSRJ11uRJEnX+8ll2mYCZNI2O0AmQCZtMwHyBCDfpG12gJwA8oS2mQA51TafBuRU2zwByKRtTgDZaZsTQCZt8wQgk7a5CZATQHba5kTbnALy161IkqTrrUiSpOutSJKk661IkqTrrUiSpOutSJKk6/3kFwDZaZsJkBNAdtrmbW1zAsikbXaATIBM2uZtbTMBstM2EyAn2uYJbXMKyC2AnAIyaZtJ20yA7LTNBMikbU4BeVvbfFrb7ACZtM0t2mYHyJtWJEnS9VYkSdL1ViRJ0vVWJEnS9VYkSdL1ViRJ0vVWJEnS9X7yh7TNBMgOkE9rmx0gk7aZtM3bgJxqmwmQCZBJ2+wAmbTNE4BM2mYCZNI2O20zATJpm1Nt82ltswNkAmTSNm8DMmmbU20zATJpmx0gJ9rmCUAmbfOEtvkLViRJ0vVWJEnS9VYkSdL1ViRJ0vVWJEnS9VYkSdL1fvKFgLytbU4AmQB5G5C3tc0T2mYCZKdtJkDeBuQWQE61zRPa5gSQU0AmbTMBcpO2+TQgO20zATIBcqptTgCZtM03WZEkSddbkSRJ11uRJEnXW5EkSddbkSRJ11uRJEnX+8kvaJsdICeATNpmB8intc0pIJO2OdU2J4BMgOy0zaRtJkBOAfm0tnkbkJ22OQHkX9A2EyCngDyhbSZAJm1zCsikbSZAntA2EyBPAPIXrEiSpOutSJKk661IkqTrrUiSpOutSJKk661IkqTrlf/kZW2zA2TSNhMgp9rm04DstM0JIE9om38BkBNtcwrIibb5NkAmbTMBcqptJkAmbfM2IKfaZgJk0jYTIDtt82lATrXNBMgT2uYJQN60IkmSrrciSZKutyJJkq63IkmSrrciSZKutyJJkq63IkmSrveTL9Q2n9Y2O0BOtM2kbZ7QNhMgO20zAfKEtjkBZNI2O0A+DchO23wakJ22mQB5G5BJ2/zr2mYHyAkgk7Y5BeQJbfNpbXMKyKRtJkC+yYokSbreiiRJut6KJEm63ookSbreiiRJut6KJEm63k9+AZCdtjnRNqfa5tOAvK1tntA2TwByAshO25wAcgrIibaZADnVNk8AMmmbCZBJ25xqmwmQSdvcpG0mQCZAdtrmRNs8AcikbSZATrXNX7AiSZKutyJJkq63IkmSrrciSZKutyJJkq63IkmSrlf+k4u0zQkg36ZtTgB5QtucAPKEtpkAuUnbTIBM2uYJQE61zQTILdpmB8iJtpkAeULbTIDstM0JIG9rm5sAedOKJEm63ookSbreiiRJut6KJEm63ookSbreiiRJut5PfkHbvK1tbgLkmwCZtM0OkEnbvK1t3gbkBJBTbXOibXaAnGibtwGZALlJ25xomx0gk7a5BZCdtpkA+QtWJEnS9VYkSdL1ViRJ0vVWJEnS9VYkSdL1ViRJ0vVWJEnS9X7yhYCcaJsJkJ22mQA50TY3ATJpm78CyKRtJkB22uZtbTMB8q9rmycAOdE2p4CcaJudtjnRNhMgN2mbCZBJ2+wAedOKJEm63ookSbreiiRJut6KJEm63ookSbreiiRJut5PfgGQnbaZAJkAeULbTID8FW0zATJpmycAmbTNKSBPADJpG82AnGqbE0B22mbSNieA7LTN24BM2uYWbfOEtpkA+SYrkiTpeiuSJOl6K5Ik6XorkiTpeiuSJOl6K5Ik6Xo/+UJAJm0zAXIKyNuAnGibCZC/om3eBmTSNjtATgA51TaTtpkAOdU2n9Y2p4BM2uabtM0OkE8DcgrI29pmAmTSNqeATNrmFiuSJOl6K5Ik6XorkiTpeiuSJOl6K5Ik6XorkiTpej/5Qm3zaW3zbdrmBJAnAJm0zQTI24DstM2JtpkA2WmbT2ubJ7TNKSD6O9pmAmTSNm9rm1NAJm1zom12gLxpRZIkXW9FkiRdb0WSJF1vRZIkXW9FkiRdb0WSJF1vRZIkXe8nv6BtntA2p4B8WtvsADnRNm8DMmmbJwCZtM0OkG8C5AlAPq1tdtrmBJBv0jangDyhbd4G5G1APq1tdtrmBJBbrEiSpOutSJKk661IkqTrrUiSpOutSJKk661IkqTr/UT/r7aZAPkmQL4NkEnb6BltMwFyCsjb2uYEkG/SNjtAPq1tTrXN29pmAuQUkEnbTNrmFJA3rUiSpOutSJKk661IkqTrrUiSpOutSJKk661IkqTr/UT/LyC3aJtTQJ7QNhMgk7aZANlpmxNAJm1zEyBPaJsJkCcAmbTNibZ5G5Cdtvk0IDttcwLIpG1OAXkbkL9gRZIkXW9FkiRdb0WSJF1vRZIkXW9FkiRdb0WSJF3vJ/qftnlb20yA3ALITttM2mYC5F/QNqfa5pu0zQkgO20zATJpm5sAOdE2TwDyhLZ5W9tMgEzaZgLkm6xIkqTrrUiSpOutSJKk661IkqTrrUiSpOutSJKk661IkqTr/eQLAZm0zQTIpG12gHxa25xqm7e1zQTIKSCf1jY7QE60zRPa5m1AJm1zCsintc1fAeRf0DYTIKfa5gSQJwCZtM0OkDetSJKk661IkqTrrUiSpOutSJKk661IkqTrrUiSpOv95Au1zQTIpG0mQHba5tOAnGqbE0BOtc2JttkBcqJt3gZk0jY7QCZtMwEyaZsdICeAfBMgStpmAuQJQL4JkEnbnGqbE0AmQL7JiiRJut6KJEm63ookSbreiiRJut6KJEm63ookSbreT34BkJ22eRuQE23zBCAn2uYUkBNAdtrmbW1zAsgEyBPa5iZt802AnACy0zYTIJO2OQVk0jZPaJsJkAmQb9I2/7oVSZJ0vRVJknS9FUmSdL0VSZJ0vRVJknS9FUmSdL3yn7ysbXaATNpmAuRU25wAMmmbU0AmbXMKyKRtTgDZaZsJkLe1zQTIpG1OAZm0zTcBcqpt3gbkCW1zAsiptvkLgJxqmxNAdtpmAmTSNhMg32RFkiRdb0WSJF1vRZIkXW9FkiRdb0WSJF1vRZIkXW9FkiRd7yd/SNtMgJwCcgLITtvcAsikbXaAvK1tPg3Iqbb5JkBOtc0EyIm2OdU2EyCngHxa25wCcqJtngBk0jZva5sdIJ/WNjtA3rQiSZKutyJJkq63IkmSrrciSZKutyJJkq63IkmSrveTXwDk2wCZtM0EyF8BZNI2p9pmAuQWbbMD5ASQSducAjJpmye0zROAnGibCZBTbTMBMgGy0zYn2mYC5FTbTNpmAmSnbSZA3tY2f8GKJEm63ookSbreiiRJut6KJEm63ookSbreiiRJul75T75M20yATNrmFJATbXMKyIm2+dcB2WmbCZBJ25wCMmmbWwA51TYTIN+kbXaAfFrb7AA50TYTIDttMwHytraZAJm0zQ6QT2ubHSBvWpEkSddbkSRJ11uRJEnXW5EkSddbkSRJ11uRJEnX+8kvaJsnAHlC20yAnGqbCZAJkFNt82lAdtrmBJBTQCZtcwLITttMgEzaZgLk27TNBMgT2ubTgOy0zQTIpG2e0DYTIDdpmwmQt7XNCSDfZEWSJF1vRZIkXW9FkiRdb0WSJF1vRZIkXW9FkiRdb0WSJF3vJ78AyE7bfFrbnAJyom1Otc0JIKeATNrmCUAmbXMKyKe1zbdpm08DcqptngDkRNu8DcikbXba5kTbnAJyom1OAZm0zQTIBMgpICfaZgfIm1YkSdL1ViRJ0vVWJEnS9VYkSdL1ViRJ0vVWJEnS9X7yC9pmB8ikbZ4AZNI2TwAyaZsJkEnbnGqbCZB/AZBv0jangEzaZtI2TwAyaZudtjkBZNI2p9rmBJBTbXMCyE7bfBqQnbZ5W9ucAHKLFUmSdL0VSZJ0vRVJknS9FUmSdL0VSZJ0vRVJknS9n/wCIN+mbSZAbgHkbW3zBCCn2ubT2uZtQP4FQE61zQkgT2ibU20zATJpm0nbPAHIpG12gEza5m1AJm1zixVJknS9FUmSdL0VSZJ0vRVJknS9FUmSdL0VSZJ0vfKfvKxtdoCcaJsJkJ22+TQgT2ibCZBTbXMCyE7bTIBM2uYUkEnbTIC8rW1OAfm0ttkBMmmbE0Ce0DbfBMi3aZsTQE61zQTIpG0mQHba5gSQSdvsAHnTiiRJut6KJEm63ookSbreiiRJut6KJEm63ookSbreiiRJut5PfgGQU20zATJpm1NAJm1zqm0mQE60zQ6QCZBJ20za5lTbTIA8AcikbU4B+QuA7LTNBMikbU61zQTIBMikbXaATNrmRNvsAPkmQP4KIJO2OQHkm6xIkqTrrUiSpOutSJKk661IkqTrrUiSpOutSJKk6/1E/wNk0jZPAPJpQHbaZgLkX9A2J4DstM0EyAkgO20zATJpmwmQU23ztraZAJkA2WmbE0AmbfOEtpkAOdU2EyCTttkB8k2A/AUrkiTpeiuSJOl6K5Ik6XorkiTpeiuSJOl6K5Ik6Xo/+QVtswNkAmTSNhMgp4Dcom12gEza5gSQnbaZAPkmQJ7QNt8EyDdpm1NAJm0zAXKTtrkFkG/TNieATNpmB8ibViRJ0vVWJEnS9VYkSdL1ViRJ0vVWJEnS9VYkSdL1fvILgOy0zQTIBMikbZ4A5FTbfBqQbwNk0jYTIJO22QFyom2eAOQJQCZtMwEyaZsdIJ/WNqfaZgLkCUBOAHlb2+wAmbTNpG1OAZm0zQTIE4D8BSuSJOl6K5Ik6XorkiTpeiuSJOl6K5Ik6XorkiTpeiuSJOl6P/lHANlpmwmQv6JtTgB5ApAntM0EyBPaZtI2TwAyATJpmwmQnbaZAJm0zTdpmx0gb2ubCZBJ20yA7LTNCSCTttlpmxNtcwrIX7ciSZKutyJJkq63IkmSrrciSZKutyJJkq63IkmSrlf+k4u0zS2APKFtTgH5C9pmB8g3aZsJkEnbnAIyaZsJkFNtcwLITttMgEza5glAJm3zNiCTttkBcqJtJkB22mYC5ETb7ACZtM0JIN9kRZIkXW9FkiRdb0WSJF1vRZIkXW9FkiRdb0WSJF3vJ7+gbZ4AZNI2O0BOtM2kbd4GZKdtPg3ITttMgEza5lTbfBqQnbaZAJm0zduAvA3IKSBvAzJpmwmQSds8oW0mQHbaZgLkRNvcBMhfsCJJkq63IkmSrrciSZKutyJJkq63IkmSrrciSZKu95M/pG0mQE61zQTIpG12gJxom2/SNjtATgCZtM0OkE9rmx0gk7Z5W9toBmSnbU60zROAPAHIpG0mQCZtc6ptdGZFkiRdb0WSJF1vRZIkXW9FkiRdb0WSJF1vRZIkXW9FkiRdr/wnekTb7ACZtM0TgEzaZgLkX9A2EyA7bXMCyKRtdoB8WtvsAJm0zQkg36ZtJkAmbfM2IN+kbXaAfFrb7ACZtM0EyC1WJEnS9VYkSdL1ViRJ0vVWJEnS9VYkSdL1ViRJ0vV+8gva5q8A8gQgk7Y51TYn2mYCZKdtJkAmbXMKyKRt3gbkbW0zAfI2IKfaZgJk0jYTIDtAJm0zAXKqbSZAJm1zCsiJtnlC20yAPAHIpG1OAXnTiiRJut6KJEm63ookSbreiiRJut6KJEm63ookSbreT74QkG/SNk9omwmQCZBTbTMBcqJtdoB8GpAnAHlb2zwByDdpmye0zQTIpG12gEyATNpmAmQHyKRtJkAmbbPTNt8EyBPaZgLkBJBvsiJJkq63IkmSrrciSZKutyJJkq63IkmSrrciSZKuV/6Tl7XNDpBJ2zwByKRtJkBOtc0EyKRtngBk0jYTIKfaZgLkVNu8Dcintc23AfK2tvkmQN7WNieAnGqbCZBJ29wEyIm22QHyphVJknS9FUmSdL0VSZJ0vRVJknS9FUmSdL0VSZJ0vRVJknS9n+gxbbMDZNI2TwAyaZsJkEnbnAIyaZsJkG/TNp8GZKdtTgA51TYTIJO2OQXk09pmB8ikbSZAJm2zA2QC5ETbnAIyaZtTQCZtMwEyaZsdIJO2mQC5xYokSbreiiRJut6KJEm63ookSbreiiRJut6KJEm63k/0a9pmAmTSNm9rmwmQU20zAfI2IJO22QEyaZsJkEnbvK1tTrXNCSA7bTMBMmmbt7XNqbb5NCA7bfNpQHba5kTbPAHIpG0mQL7JiiRJut6KJEm63ookSbreiiRJut6KJEm63ookSbreTy4D5BZAdtpm0jYTIKfaZgJk0jZPADJpm1NAJm0zaZsnAHkCkEnbPAHIibaZtM0OkBNAJm3zBCCTttkBMmmbCZBJ25xqm7cBmbTNqbY5AeQWK5Ik6XorkiTpeiuSJOl6K5Ik6XorkiTpeiuSJOl65T95Wdv8FUAmbbMDZNI2J4CcapsJkLe1zSkgJ9rmFJBv0jYTIKfa5gSQSducAvK2tjkBZKdtJkAmbfMEIJO2OQVk0jYngOy0zduAvGlFkiRdb0WSJF1vRZIkXW9FkiRdb0WSJF1vRZIkXW9FkiRdr/wnkiTpaiuSJOl6K5Ik6XorkiTpeiuSJOl6K5Ik6XorkiTpeiuSJOl6K5Ik6XorkiTpeiuSJOl6K5Ik6XorkiTpeiuSJOl6K5Ik6XorkiTpeiuSJOl6K5Ik6XorkiTpeiuSJOl6K5Ik6XorkiTpeiuSJOl6K5Ik6XorkiTpeiuSJOl6K5Ik6XorkiTpev8Hd3aKgq5AEfcAAAAASUVORK5CYII=";

    const qrCodebase64ComPrefixo = `data:image/png;base64,${props.qrCodeBase64}`;

    const qrLoading = (
        <div
            style={{
                position: "relative",
                display: "inline-block", // permite a imagem manter o tamanho original
            }}
        >
            <img
                src={QR_FAKE_BASE64}
                alt="QR Fake"
                style={{
                    width: "250px", height: "250px",
                    objectFit: "contain",
                    display: "block",
                }}
            />

            <div
                style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "rgba(255, 255, 255, 0.89)", // fundo translúcido opcional
                    pointerEvents: "none", // permite clicar na imagem se necessário
                }}
            >
                <div
                    style={{
                        border: "12px solid #CDCDCD",
                        borderTop: "12px solid #2196f3",
                        borderRadius: "70%",
                        width: "80px",
                        height: "80px",
                        animation: "spin 1s linear infinite",
                        marginBottom: "12px",
                        backgroundColor: "rgba(255, 255, 255, 0.70)", // fundo translúcido opcional
                    }}
                />
                <span
                    style={{
                        fontSize: "16px",
                        color: "#2196f3",
                        fontWeight: "bold",
                        backgroundColor: "rgba(255, 255, 255, 0.5)", // fundo translúcido opcional
                    }}
                ><strong> Gerando QR Code...</strong></span>
            </div>

            <style>
                {`
        @keyframes spin {
          0%   { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}
            </style>
        </div>
    );

const conteudoModal = (
    <div className={estiloModalConfigurarWhatsapp.conteudoModal}>
        {props.erroAoObterQrCode ? (
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "300px",
                    height: "300px",
                    textAlign: "center",
                }}
            >
                <FontAwesomeIcon
                    icon={faX}
                    style={{ color: "red", fontSize: "100px", marginBottom: "20px" }}
                />
                <span style={{ color: "red", fontWeight: "bold", fontSize: "18px" }}>
                    Não foi possível obter o QR Code.
                </span>
            </div>
        ) : globalMU.isNullOrEmpty(props.qrCodeBase64) ? (
            qrLoading
        ) : (
            <img
                src={qrCodebase64ComPrefixo}
                alt="QR Code"
                style={{ width: "300px", height: "300px" }}
            />
        )}
        <br />
    </div>
);

    const dialogActions = (
        <DialogActions
            style={{
                justifyContent: "right",
                minWidth: "350px",
                display: "block",
            }}
            disableSpacing={true}
            className={estiloModalConfigurarWhatsapp.dialogActions}
        >
            <div className={estiloModalConfigurarWhatsapp.modalActions}>
                <button
                    className={`no-global-button ${estiloModalConfigurarWhatsapp.botaoApagarDadosSessao}`}
                    onClick={() => {
                        props.onApagarSessao(false);
                    }}
                    style={{display: "none"}}
                >
                    <FontAwesomeIcon icon={faBan} size="sm" />
                    Apagar Dados Sessão
                </button>
                <button
                    className={
                        estiloModalConfigurarWhatsapp.buttonModalConfigurarWhatsapp
                    }
                    style={{
                        margin: "0 3px 0 0",
                        padding: "7px 1em",
                    }}
                    onClick={async () => {
                        !props.carregandoQrCode && props.onGerarQrCode({
                            qrCodeBase64: props.qrCodeBase64,
                        });
                    }}
                >
                    Gerar Novo Qr Code
                </button>
            </div>
        </DialogActions>
    );

    return (
        <>
            <Dialog
                open={true}
                onClose={props.onClose}
                scroll={scroll}
                className={estiloModalConfigurarWhatsapp.dialogModalSenha}
                PaperComponent={PaperArrastavel}
            >
                <div className={estiloModalConfigurarWhatsapp.titulo} data-arrastar-dialog>
                    <h4 style={{ fontWeight: 700 }}>
                        Configurar WhatsApp Específico Vendedor
                    </h4>
                    <div>
                        <a onClick={props.onClose}>
                            <FontAwesomeIcon
                                icon={faTimes}
                                cursor={"pointer"}
                                className={estiloModalConfigurarWhatsapp.exit}
                                opacity={0.2}
                            />
                        </a>
                    </div>
                </div>
                <DialogContent
                    dividers={scroll === "paper"}
                    style={{ padding: "15px" }}
                >
                    {conteudoModal}

                    <br />
                    <br />
                    <br />

                    {dialogActions}
                </DialogContent>
            </Dialog>
        </>
    );
};
